import "bootstrap"
import "bootstrap-icons/font/bootstrap-icons.css"
import "bootstrap/dist/css/bootstrap.min.css"

import {createApp} from 'vue'
import App from './App.vue'
import {router, initRouter} from "@/router";
import {initAuth} from "@/state/auth";
import ErrorPage from "@/ErrorPage";
import {config} from "@/state/config";


async function initApp() {
  try {
    await config.init();
    await initAuth();
    initRouter();
    createApp(App)
      .use(router)
      .mount('#app');
  } catch (e) {
    console.error("initApp error", e);
    createApp(ErrorPage)
      .mount('#app');
  }
}

const _ = initApp();